'use strict';

/**
 * Opencare AI disablement survey modal.
 */
angular.module('ClinicApp').controller('DisableAiModalCtrl', function(
  clinicId,
  $scope,
  $modalInstance,
  GrowlService,
  FeedbackService,
  CurrentUser,
) {
  const TOTAL_STEPS = 3;
  const OTHER_REASON = 'Other';
  const FEEDBACK_SOURCE = 'OPENCARE_AI_DISABLEMENT';
  const FEEDBACK_MODEL_TYPE = 'Clinic';

  $scope.totalSteps = TOTAL_STEPS;
  $scope.step = 1;
  $scope.isSubmitting = false;

  $scope.reasons = [
    'AI was sharing inaccurate or off-brand information with patients',
    'AI was responding before our staff had a chance to',
    "Scheduling didn't match how our practice runs",
    "Patients scheduled by AI weren't showing up",
    'Technical issues with our PMS or integration',
    'Patient feedback was negative',
    "Didn't see enough value to keep it on",
    OTHER_REASON,
  ];

  $scope.survey = {
    selectedReasons: {},
    otherReason: '',
    comment: '',
    isFollowUpNeeded: null,
  };

  const getSelectedReasons = () => $scope.reasons.filter((reason) => $scope.survey.selectedReasons[reason]);

  $scope.isOtherSelected = () => !!$scope.survey.selectedReasons[OTHER_REASON];

  $scope.hasSelectedReason = () => getSelectedReasons().length > 0;

  $scope.canGoNext = () => $scope.step > 1 || $scope.hasSelectedReason();

  $scope.next = () => {
    if ($scope.step < TOTAL_STEPS && $scope.canGoNext()) {
      $scope.step++;
    }
  };

  $scope.back = () => {
    if ($scope.step > 1) {
      $scope.step--;
    }
  };

  $scope.setFollowUpNeeded = (isFollowUpNeeded) => {
    $scope.survey.isFollowUpNeeded = isFollowUpNeeded;
  };

  const buildSourceData = () => {
    const sourceData = {
      reasons: getSelectedReasons(),
      comment: $scope.survey.comment || null,
      isFollowUpNeeded: typeof $scope.survey.isFollowUpNeeded === 'boolean'
        ? $scope.survey.isFollowUpNeeded
        : null,
    };

    if (sourceData.reasons.includes(OTHER_REASON) && $scope.survey.otherReason) {
      const index = sourceData.reasons.indexOf(OTHER_REASON);
      sourceData.reasons[index] = `Other: ${$scope.survey.otherReason}`;
    }

    return sourceData;
  };

  $scope.submit = async () => {
    if ($scope.isSubmitting || !$scope.hasSelectedReason()) {
      return;
    }

    $scope.isSubmitting = true;

    try {
      await FeedbackService.submitFeedback({
        source: FEEDBACK_SOURCE,
        data: {
          [FEEDBACK_SOURCE]: buildSourceData(),
        },
        modelType: FEEDBACK_MODEL_TYPE,
        modelId: clinicId,
        user: CurrentUser.getUser().id,
      });

      GrowlService.success('Your feedback has been submitted.');

      $modalInstance.close();
    } finally {
      $scope.isSubmitting = false;
      $scope.$apply();
    }
  };

  $scope.close = () => {
    $modalInstance.close();
  };
});
